import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const DollarIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--dollarIcon')}
    viewBox="0 0 32 34"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M16.5 5C22.851 5 28 10.149 28 16.5S22.851 28 16.5 28 5 22.851 5 16.5 10.149 5 16.5 5Zm0 1.5c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10Zm.52 4v1.384c.82.114 1.49.412 2.01.893.522.482.86 1.083 1.015 1.805l-1.444.275c-.183-.877-.71-1.444-1.581-1.702v2.742c.183.046.422.114.717.206l.58.18c.373.115.695.261.967.439.272.177.48.374.623.589a2.164 2.164 0 0 1 .404 1.268c-.005.55-.159 1.025-.46 1.426-.3.4-.688.716-1.164.945a4.858 4.858 0 0 1-1.667.455v1.341h-1.006v-1.358c-1.203-.097-2.076-.435-2.62-1.014-.436-.452-.728-1.051-.877-1.796l1.435-.25c.218.826.659 1.39 1.323 1.694.2.08.447.143.74.189v-3.025l-.319-.069-.79-.197a3.643 3.643 0 0 1-1.087-.452c-.324-.203-.566-.428-.726-.674a2.45 2.45 0 0 1-.254-.602c-.06-.218-.09-.39-.09-.515l-.009-.19c.017-.372.093-.708.228-1.01.135-.3.308-.54.52-.721.212-.18.431-.335.657-.464a2.68 2.68 0 0 1 .735-.284c.264-.06.478-.103.645-.129.166-.025.329-.041.49-.047V10.5h1.005Zm0 6.892v2.836a2.41 2.41 0 0 0 .864-.202c.237-.112.406-.236.507-.374.1-.137.177-.273.232-.408a.943.943 0 0 0 .081-.34v-.137a1.073 1.073 0 0 0-.03-.322 1.412 1.412 0 0 0-.09-.258.757.757 0 0 0-.15-.206 2.3 2.3 0 0 0-.168-.155.945.945 0 0 0-.202-.116 4.188 4.188 0 0 0-.19-.081 6.129 6.129 0 0 0-.313-.108 5.081 5.081 0 0 0-.541-.129Zm-1.006-4.383c-.487.006-.89.138-1.207.396-.318.258-.486.527-.503.808-.023.211.005.398.082.558.077.16.203.295.378.404.175.109.357.2.546.27.189.072.424.142.704.211V13.01Z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default DollarIcon;
